// extracted by mini-css-extract-plugin
module.exports = {"filterContainer":"DataTableFilter_filterContainer__1eDJj","clearFilters":"DataTableFilter_clearFilters__15bJ8"};